import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=6d72dce8&scoped=true&"
import script from "./switch.vue?vue&type=script&lang=js&"
export * from "./switch.vue?vue&type=script&lang=js&"
import style0 from "./switch.vue?vue&type=style&index=0&id=6d72dce8&prod&lang=scss&"
import style1 from "./switch.vue?vue&type=style&index=1&id=6d72dce8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d72dce8",
  null
  
)

export default component.exports